export default "__VITE_ASSET__Ycd1u43p__"